import { createActions } from 'redux-actions';

export const {
  // GET REQUESTS
  getEmployees,
  getEmployeesSuccess,
  getEmployeesError,
  // POST REQUEST
  // PUT REQUEST
  // DELETE REQUEST
  // OTHER
  getEmployeesSearch,
  getEmployeesSearchSuccess,
  getDrivers,
  getDriversSuccess,
  getDriversFailure,
} = createActions(
  'GET_EMPLOYEES',
  'GET_EMPLOYEES_SUCCESS',
  'GET_EMPLOYEES_ERROR',
  'GET_EMPLOYEES_SEARCH',
  'GET_EMPLOYEES_SEARCH_SUCCESS',
  'GET_DRIVERS',
  'GET_DRIVERS_SUCCESS',
  'GET_DRIVERS_FAILURE'
);
